/**
 * TASKS-ADD.MODAL
 * Create new action plan (for myself or a manager)
 */
import { v4 as uuid } from "uuid"
import Modal from "@/components/modal"
import { WithTranslation, withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Session } from "@/redux/_session.types"
import { useState } from "react"
import { store } from "@/index"
import { SurveyState } from "@/redux/survey.types"
import { actionPlanActivate, actionPlanUpdate } from "@/redux/action-plan.actions"
import { ActionPlan } from "@/redux/action-plan.types"
import SurveySelectWidget from "@/widgets/survey-select.widget"
import GetSurveyResultsModal from "./get-survey-results.modal"
import { userActivate } from "@/redux/user.actions"
import { User } from "@/redux/user.types"

interface StateProps extends WithTranslation {
  _session: Session
  survey: SurveyState
}

interface OwnProps {
  onClose: Function
}

type Props = StateProps & OwnProps

function TasksAddModal(props: Props) {
  const { t } = props

  const [isSaving, setIsSaving] = useState(false)

  async function create() {
    const currentUser = new User({
      id: props._session.userId,
      email: props._session.email,
      firstname: props._session.userFirstname,
      lastname: props._session.userLastname,
      role: props._session.userRole
    })

    const actionPlan: any = await store.dispatch(
      actionPlanUpdate(
        new ActionPlan({
          id: uuid(),
          SurveyId: props.survey.active.id,
          UserId: currentUser.id
        })
      )
    )
    if (!actionPlan.error) {
      store.dispatch(actionPlanActivate(new ActionPlan({ ...actionPlan, User: currentUser })))
      store.dispatch(userActivate(currentUser))
      setIsSaving(true)
    }
  }

  return (
    <Modal isCloseButtonVisible title={t("tasks_add")} onClose={() => props.onClose()} onNext={create}>
      {isSaving && <GetSurveyResultsModal onClose={() => setIsSaving(false)} destination="/tasks/edit" />}
      <SurveySelectWidget />
      <div className="h-[320px]" />
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session,
  survey: state.survey
})

export default connect(mapStateToProps)(withTranslation()(TasksAddModal))
